module.exports = __webpack_public_path__ + "static/media/jabberwocky.e1bde902.gif";